import {
  IndustrialCompanyScale,
  IcxRegion,
  IndustrialComplexName,
  IndustrialSectorsCategory,
  IndustrialSectorsName
} from '@generated/graphql';

export const filterEnumToString = (
  value:
    | IcxRegion
    | IndustrialCompanyScale
    | IndustrialSectorsName
    | IndustrialSectorsCategory
    | IndustrialComplexName
) => {
  switch (value) {
    /* IcxRegion */
    case IcxRegion.Busan:
      return '부산';
    case IcxRegion.Chungbuk:
      return '충북';
    case IcxRegion.Chungnam:
      return '충남';
    case IcxRegion.DaeJeon:
      return '대전';
    case IcxRegion.GwangJu:
      return '광주';
    case IcxRegion.Daegu:
      return '대구';
    case IcxRegion.Geyongbuk:
      return '경북';
    case IcxRegion.Geyongnam:
      return '경남';
    case IcxRegion.Gyeonggi:
      return '경기';
    case IcxRegion.Incheon:
      return '인천';
    case IcxRegion.Jeju:
      return '제주';
    case IcxRegion.Jeonbuk:
      return '전북';
    case IcxRegion.Jeonnam:
      return '전남';
    case IcxRegion.Seoul:
      return '서울';
    case IcxRegion.Ulsan:
      return '울산';
    case IcxRegion.Gangwon:
      return '강원';

    case IndustrialSectorsCategory.NonManufacturing:
      return '비제조';
    case IndustrialSectorsCategory.Produce:
      return '제조';

    case IndustrialComplexName.IndustrialComplex_1:
      return '남동국가산업단지';
    case IndustrialComplexName.IndustrialComplex_2:
      return '광양국가산업단지';
    case IndustrialComplexName.IndustrialComplex_3:
      return '광주월전중소협력단지형외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_4:
      return '광주첨단과학국가산업단지';
    case IndustrialComplexName.IndustrialComplex_5:
      return '구미국가산업단지';
    case IndustrialComplexName.IndustrialComplex_6:
      return '구미외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_7:
      return '국가식품클러스터국가산업단지';
    case IndustrialComplexName.IndustrialComplex_8:
      return '국가식품클러스터식품산업단지중소협력단지형외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_9:
      return '군산2국가산업단지';
    case IndustrialComplexName.IndustrialComplex_10:
      return '군산국가산업단지';
    case IndustrialComplexName.IndustrialComplex_11:
      return '김해GoldenRoot일반산업단지';
    case IndustrialComplexName.IndustrialComplex_12:
      return '달성2차외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_13:
      return '달성2차일반산업단지';
    case IndustrialComplexName.IndustrialComplex_14:
      return '대구국가산업단지';
    case IndustrialComplexName.IndustrialComplex_15:
      return '대불국가산업단지';
    case IndustrialComplexName.IndustrialComplex_16:
      return '대불외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_17:
      return '명지녹산국가산업단지';
    case IndustrialComplexName.IndustrialComplex_18:
      return '문막중소협력단지형외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_19:
      return '반월국가산업단지';
    case IndustrialComplexName.IndustrialComplex_20:
      return '부산신평장림일반산업단지(협업단지)';
    case IndustrialComplexName.IndustrialComplex_21:
      return '북평국가산업단지';
    case IndustrialComplexName.IndustrialComplex_22:
      return '빛그린국가산업단지';
    case IndustrialComplexName.IndustrialComplex_23:
      return '서울디지털국가산업단지';
    case IndustrialComplexName.IndustrialComplex_24:
      return '시화국가산업단지';
    case IndustrialComplexName.IndustrialComplex_25:
      return '시화멀티테크노밸리';
    case IndustrialComplexName.IndustrialComplex_26:
      return '아산국가산업단지(포승지구)';
    case IndustrialComplexName.IndustrialComplex_27:
      return '여수국가산업단지';
    case IndustrialComplexName.IndustrialComplex_28:
      return '오송생명과학단지';
    case IndustrialComplexName.IndustrialComplex_29:
      return '온산국가산업단지';
    case IndustrialComplexName.IndustrialComplex_30:
      return '울산미포국가산업단지';
    case IndustrialComplexName.IndustrialComplex_31:
      return '익산국가산업단지';
    case IndustrialComplexName.IndustrialComplex_32:
      return '장성동화농공단지';
    case IndustrialComplexName.IndustrialComplex_33:
      return '장성삼계농공단지';
    case IndustrialComplexName.IndustrialComplex_34:
      return '창원국가산업단지';
    case IndustrialComplexName.IndustrialComplex_35:
      return '청주오송제2생명과학일반산업단지(충북경제자유구역 오송바이오폴리스지구)';
    case IndustrialComplexName.IndustrialComplex_36:
      return '한국수출산업(부평)국가산업단지';
    case IndustrialComplexName.IndustrialComplex_37:
      return '한국수출산업(주안)국가산업단지';
    case IndustrialComplexName.IndustrialComplex_38:
      return '석문국가산업단지';
    case IndustrialComplexName.IndustrialComplex_39:
      return '아산국가산업단지(고대부곡지구)';
    case IndustrialComplexName.IndustrialComplex_40:
      return '충주외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_41:
      return '파주탄현중소기업전용국가산업단지';
    case IndustrialComplexName.IndustrialComplex_42:
      return '원주문막반계일반산업단지';
    case IndustrialComplexName.IndustrialComplex_43:
      return '북평일반산업단지';
    case IndustrialComplexName.IndustrialComplex_44:
      return '양주홍죽일반산업단지';
    case IndustrialComplexName.IndustrialComplex_45:
      return '송산2외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_46:
      return '사천제2일반산업단지';
    case IndustrialComplexName.IndustrialComplex_47:
      return '송산2-1외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_48:
      return '사천제1일반산업단지';
    case IndustrialComplexName.IndustrialComplex_49:
      return '사천외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_50:
      return '아산제2테크노밸리일반산업단지';
    case IndustrialComplexName.IndustrialComplex_51:
      return '이천장호원일반산업단지';
    case IndustrialComplexName.IndustrialComplex_52:
      return '천안외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_53:
      return '사천임대전용산업단지';
    case IndustrialComplexName.IndustrialComplex_54:
      return '천안5산단외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_55:
      return '진해국가산업단지';
    case IndustrialComplexName.IndustrialComplex_56:
      return '진천산수외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_57:
      return '이천대월일반산업단지';
    case IndustrialComplexName.IndustrialComplex_58:
      return '인주외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_59:
      return '포항국가산업단지';
    case IndustrialComplexName.IndustrialComplex_60:
      return '장항국가생태산업단지';
    case IndustrialComplexName.IndustrialComplex_61:
      return '오창외국인투자지역';
    case IndustrialComplexName.IndustrialComplex_62:
      return '포항블루밸리국가산업단지';
    case IndustrialComplexName.IndustrialComplex_63:
      return '안정국가산업단지';
    case IndustrialComplexName.IndustrialComplex_64:
      return '송산2-2외국인투자지역';

    case IndustrialSectorsName.SectorName_1:
      return '음식료';
    case IndustrialSectorsName.SectorName_2:
      return '섬유의복';
    case IndustrialSectorsName.SectorName_3:
      return '목재종이';
    case IndustrialSectorsName.SectorName_4:
      return '석유화학';
    case IndustrialSectorsName.SectorName_5:
      return '비금속';
    case IndustrialSectorsName.SectorName_6:
      return '철강';
    case IndustrialSectorsName.SectorName_7:
      return '기계';
    case IndustrialSectorsName.SectorName_8:
      return '전기전자';
    case IndustrialSectorsName.SectorName_9:
      return '운송장비';
    case IndustrialSectorsName.SectorName_10:
      return '(제조)기타';
    case IndustrialSectorsName.SectorName_11:
      return '정보통신업';
    case IndustrialSectorsName.SectorName_12:
      return 'SECTOR_NAME_12';
    case IndustrialSectorsName.SectorName_13:
      return '출판업';
    case IndustrialSectorsName.SectorName_14:
      return '(비제조)기타';

    case IndustrialCompanyScale.SmallCompany:
      return '소기업';
    case IndustrialCompanyScale.MidSizedCompany:
      return '중기업';
    case IndustrialCompanyScale.MajorCompany:
      return '대기업';

    default:
      return '미분류';
  }
};
